import type { PurchaseActionType } from '@/types';

const purchaseActionClassnames = {
  BackOrder: 'product__purchase-options--out-of-stock',
  Notify: 'product__purchase-options--notify',
  PreOrder: 'product__purchase-options--pre-order',
} as const;

export const addPurchaseActionClassname = (
  purchasingPortal: Element,
  purchaseAction: PurchaseActionType,
) => {
  const { classList } = purchasingPortal;
  const className =
    purchaseActionClassnames[
      purchaseAction as keyof typeof purchaseActionClassnames
    ];

  if (className && !classList.contains(className)) {
    classList.add(className);
  }
};
